import React from 'react'
import { Container, Image } from '@pmi/pmi-iqos-ds-react'

const ProductBanner = ({ image }) => {
  return (
    <Container fullWidth>
      <Image width="full" src={image.image_path} alt={image.alt} />
    </Container>
  )
}

export default ProductBanner
